export default __webpack_public_path__ + "static/media/fondo.167d442c.jpg";